import { useCallback, useEffect, useState } from 'react';
import { guardarEmpresa, leerEmpresasLocales, limpiarEmpresa, sincronizarEmpresas } from '../services/empresaService';

/**
 * Empresas del postor: arranca con la copia de este navegador y las sincroniza con la
 * cuenta del correo indicado. La pantalla nunca queda bloqueada por un fallo de red.
 */
export default function useEmpresas(email) {
  const [empresas, setEmpresas] = useState(leerEmpresasLocales);
  const [cargando, setCargando] = useState(true);
  const [enLaNube, setEnLaNube] = useState(false);
  const [revision, setRevision] = useState(0);

  const reintentar = useCallback(() => setRevision(valor => valor + 1), []);

  useEffect(() => {
    let activo = true;
    setCargando(true);
    sincronizarEmpresas(email).then(resultado => {
      if (!activo) return;
      setEmpresas(resultado.empresas);
      setEnLaNube(resultado.enLaNube);
      setCargando(false);
    });
    return () => { activo = false; };
  }, [email, revision]);

  const guardar = useCallback(async (tipo, datos) => {
    const { enLaNube: sincronizado } = await guardarEmpresa(email, tipo, datos);
    setEmpresas(actuales => ({ ...actuales, [tipo]: { ...datos } }));
    setEnLaNube(sincronizado);
    return sincronizado;
  }, [email]);

  const limpiar = useCallback(async tipo => {
    const { enLaNube: sincronizado } = await limpiarEmpresa(email, tipo);
    setEmpresas(actuales => ({ ...actuales, [tipo]: {} }));
    setEnLaNube(sincronizado);
    return sincronizado;
  }, [email]);

  return { empresas, guardar, limpiar, cargando, enLaNube, reintentar };
}
